import { RequestService } from '@tcc-online/request-service';

export const UsersService = {
    getUsersList,
    getUserDetail,
};

const USERS_ENDPOINT = '/users';

async function getUsersList() {
    return RequestService.get(USERS_ENDPOINT);
}

async function getUserDetail(id: number) {
    return RequestService.get(`${USERS_ENDPOINT}/${id}`);
}
